import {
    GET_CUSTOMER_BEGIN, GET_CUSTOMER_SUCCESS, GET_CUSTOMER_FAILURE,
    SET_COMPLETE_REGISTER_DATA,
    COMPLETE_REGISTER_BEGIN, COMPLETE_REGISTER_SUCCESS, COMPLETE_REGISTER_FAILURE
} from '../constants/ActionTypes'

const initialState = {
    customer: null,
    isLoadingCustomer: false,
    hasErrorCustomer: null,

    completeRegisterData: {
        password: '',
        firstName: '',
        lastName: '',
        phone: '',
        plan: null
    },
    wasSuccessfulCompleteRegister: false,
    isLoadingCompleteRegister: false,
    hasErrorCompleteRegister: null
}

/**
 * Reducer function for managing the customer state.
 *
 * @author Maria Eduarda Franke
 * @param {Object} state - The current state.
 * @param {Object} action - The action object.
 * @returns {Object} - The new state.
 */
const ReducerCustomer = (state = initialState, action) => {
    switch (action.type) {

    // Get Customer
    case GET_CUSTOMER_BEGIN: {
        return {
            ...state,
            isLoadingCustomer: true
        }
    }
    case GET_CUSTOMER_SUCCESS: {
        return {
            ...state,
            customer: action.payload,
            isLoadingCustomer: false,
            hasErrorCustomer: null
        }
    }
    case GET_CUSTOMER_FAILURE: {
        return {
            ...state,
            customer: null,
            isLoadingCustomer: false,
            hasErrorCustomer: action.payload
        }
    }

    // Complete Register
    case SET_COMPLETE_REGISTER_DATA: {
        return {
            ...state,
            completeRegisterData: {
                ...state.completeRegisterData,
                ...action.payload
            }
        }
    }
    case COMPLETE_REGISTER_BEGIN: {
        return {
            ...state,
            isLoadingCompleteRegister: true
        }
    }
    case COMPLETE_REGISTER_SUCCESS: {
        return {
            ...state,
            wasSuccessfulCompleteRegister: true,
            isLoadingCompleteRegister: false,
            hasErrorCompleteRegister: null
        }
    }
    case COMPLETE_REGISTER_FAILURE: {
        return {
            ...state,
            wasSuccessfulCompleteRegister: false,
            isLoadingCompleteRegister: false,
            hasErrorCompleteRegister: action.payload
        }
    }

    default: return state

    }
}

export default ReducerCustomer